export const STATES_MAP_CODES = { 'United States': 'USA' };
